import { reflect } from '@effector/reflect';
import { useUnit } from 'effector-react';
import { CircleSlash2 } from 'lucide-react';
import { not } from 'patronum';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import { UnblockGameModel } from '../../model';

export const createUnblockGameModal = (model: UnblockGameModel) => {
	const ConfirmModal = createConfirmModal(model);

	const UnblockGameModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		const [game] = useUnit([model.$modalData]);

		return (
			<ConfirmModal
				ref={ref}
				title={t('unblock-game.title')}
				cancelButtonProps={{
					children: t('unblock-game.cancel'),
				}}
				submitButtonProps={{
					variant: 'outline',
					children: t('unblock-game.unblock'),
				}}
				{...props}
			>
				{t('unblock-game.description', { name: game?.game.title })}
			</ConfirmModal>
		);
	});

	const UnblockGameModalActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			'data-test-id': 'unblock-game-action-icon',
			variant: 'ghost-destructive',
			disabled: not(viewerModel.$canBlockGames),
			children: <CircleSlash2 />,
		},
	});

	return Object.assign(UnblockGameModal, {
		ActionIcon: UnblockGameModalActionIcon,
	});
};
